/**
 * Standalone polyfill for <show-more-component>.
 * Replicates the behavior from Shopify's Horizon theme Component framework.
 * Handles ref="" bindings and on:click="/method" directives.
 */
if (!customElements.get('show-more-component')) {
  class ShowMoreComponent extends HTMLElement {
    connectedCallback() {
      // Build refs from ref="" attributes (same as Component base class)
      this.refs = {};
      this.querySelectorAll('[ref]').forEach((el) => {
        const key = el.getAttribute('ref');
        if (key.endsWith('[]')) {
          const name = key.slice(0, -2);
          if (!this.refs[name]) this.refs[name] = [];
          this.refs[name].push(el);
        } else {
          this.refs[key] = el;
        }
      });

      // Bind on:click="/method" directives
      this.querySelectorAll('[on\\:click]').forEach((el) => {
        const method = el.getAttribute('on:click').replace('/', '');
        if (typeof this[method] === 'function') {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this[method](e);
          });
        }
      });

      // Prevent form submission from button
      if (this.refs.showMoreButton) {
        this.refs.showMoreButton.type = 'button';
      }

      this._expanded = this.dataset.expanded === 'true';
      this._collapsedHeight = 0;
    }

    toggle(event) {
      if (!this.refs.showMoreItems || !this.refs.showMoreContent) return;

      if (!this._expanded) {
        // Expand
        this._collapsedHeight = this.refs.showMoreContent.offsetHeight;
        var startHeight = this._collapsedHeight;
        this.refs.showMoreItems.forEach((item) => item.classList.remove('hidden'));
        var endHeight = this.refs.showMoreContent.scrollHeight;

        this.dataset.expanded = 'true';
        if (this.refs.showMoreButton) this.refs.showMoreButton.setAttribute('aria-expanded', 'true');
        this._animateHeight(startHeight, endHeight, false);
      } else {
        // Collapse
        var startHeight = this.refs.showMoreContent.offsetHeight;
        var endHeight = this._collapsedHeight;

        this.dataset.expanded = 'false';
        if (this.refs.showMoreButton) this.refs.showMoreButton.setAttribute('aria-expanded', 'false');
        this._animateHeight(startHeight, endHeight, true);
      }
    }

    _animateHeight(startHeight, endHeight, hideAfter) {
      var content = this.refs.showMoreContent;
      content.style.overflow = 'hidden';

      var anim = content.animate(
        { height: [startHeight + 'px', endHeight + 'px'] },
        { duration: 300, easing: 'ease-in-out' }
      );

      anim.onfinish = () => {
        if (hideAfter) {
          this.refs.showMoreItems.forEach((item) => item.classList.add('hidden'));
        }
        content.style.removeProperty('height');
        content.style.overflow = '';
        this._expanded = !this._expanded;
      };
    }
  }

  customElements.define('show-more-component', ShowMoreComponent);
}
